import { Controller, Menu, Toolbar } from '@tencent/workbench';
import { InsertLayoutFeature } from './insert-layout-feature';
import { TOOLBAR_CONFIGS, MENU_CONFIGS, config } from './config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_CONFIGS,
    menuItems: MENU_CONFIGS,
})
export class InsertLayoutController {
    constructor(private readonly feature: InsertLayoutFeature) {}

    @Menu(config.id, 'onClick')
    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick')
    public onClick() {
        this.feature.insertLayout();
    }

    @Menu(config.id, 'shouldHide')
    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    public shouldHide() {
        return !(this.feature.curModelIsLayout || this.feature.curModelIsMaster);
    }
}
